import React from "react";

const Hero = () => {
  return (
    <div className="row justify-content-center hero-unit">
      <div className="col-xl-11">
        <div className="row">
          <div className="hero-cta">
            <h2>Whether you&apos;re ready for a paving stone driveway, patio, or pool deck, Pacific Pavingstone is the team for you.</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
